<template>
<div class="bg-purple-100 rounded-sm">
    <div class="justify-between items-center flex w-full" :class="{ 'pb-4': $slots.title }">
        <div v-if="$slots.title" class="px-4 flex items-center w-full text-2xl pt-4 mt-4 justify-between">
            <h1 class="text-lg h5">
                <slot name="title" />
            </h1>
            <slot name="actions" />
        </div>
    </div>
    <slot />
</div>
</template>

<script>
export default {
    inheritAttrs: false,
};
</script>
